<script>
export default {
    name: "IconMaxInner",
};
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1000"
        fill="none"
    >
        <defs>
            <!-- основной линейный градиент -->
            <linearGradient
                id="maxGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
            >
                <stop offset="0%" stop-color="#4cf" />
                <stop offset="66%" stop-color="#53e" />
                <stop offset="100%" stop-color="#93d" />
            </linearGradient>

            <!-- радиальная подсветка -->
            <radialGradient
                id="maxGlow"
                cx="-20%"
                cy="120%"
                r="120%"
            >
                <stop offset="0%" stop-color="rgba(0,0,255,0.35)" />
                <stop offset="60%" stop-color="rgba(0,0,255,0)" />
            </radialGradient>
        </defs>

        <!-- сама иконка -->
        <path
            fill="url(#maxGradient)"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.786 0 375.947 171.001 375.947 381.604.707 207.347-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574z"
        />

        <!-- подсвет поверх -->
        <path
            fill="url(#maxGlow)"
            fill-rule="evenodd"
            clip-rule="evenodd"
            style="mix-blend-mode: screen"
            d="M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.786 0 375.947 171.001 375.947 381.604.707 207.347-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574z"
        />
    </svg>
</template>

<style scoped>
/* специально пусто */
</style>
